import React, { useState } from "react";
import { Autocomplete, Chip, ClearIcon, Stack, TextField, } from "../styles/MaterialUI";

const MultiSelect = ({ tagList, onClose, selectedTag = [] }) => {
  const [value, setValue] = useState(selectedTag);
  const [customValue, setCustomValue] = useState("");
  const [noOptions, setNoOptions] = useState(false);

  const handleAddCustomValue = () => {
    if (customValue.trim() !== "" && !value.includes(customValue)) {
      setValue([...value, customValue]);
      onClose(value, customValue);
      setCustomValue("");
    }
  };

  const handleChange = (newValue) => {
    setValue(newValue);
    const isNotExist = !newValue.every((value) => tagList.includes(value));
    onClose(newValue, isNotExist && customValue);
    setCustomValue("");
  };

  const handleCustomValueClear = () => {
    if (customValue.trim() !== "" && !value.includes(customValue)) {
      setCustomValue("");
    }
  };

  return (
    <Autocomplete
      size="small"
      sx={{ width: "100%" }}
      multiple
      options={tagList}
      value={value}
      onChange={(event, newValue) => handleChange(newValue)}
      filterSelectedOptions
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Tags"
          value={customValue}
          onChange={(e) => {
            const textValue = e.target.value;
            setCustomValue(textValue);
            !tagList.map((tag) => tag.toLowerCase()).includes(textValue?.trim().toLowerCase()) ? setNoOptions(true) : setNoOptions(false);
          }}
          onBlur={handleCustomValueClear}
        />
      )}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={index}
            label={option}
            {...getTagProps({ index })}
            onDelete={() => {
              const newValue = [...value];
              newValue.splice(index, 1);
              onClose(newValue);
              setValue(newValue);
            }}
            deleteIcon={
              <ClearIcon
                style={{
                  fontSize: "1rem",
                  backgroundColor: "#003366",
                  color: "#fff",
                }}
              />
            }
            sx={{ m: 0.5, backgroundColor: "#003366", color: "#fff" }}
          />
        ))
      }
      renderOption={(props, option) => <li {...props}>{option}</li>}
      getOptionLabel={(option) => option}
      noOptionsText={
        <Stack direction="row" alignItems="center" justifyContent="flex-start">
          {noOptions ?
            <a
              role="button"
              onClick={handleAddCustomValue}
              style={{ cursor: "pointer", width: "100%" }}
            >
              New tag: {customValue}
            </a> : "This tag already selected."
          }
        </Stack>
      }
    />
  );
};

export default MultiSelect;
